<template>
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary"
                >الصفحة الرئيسية</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">شروط الخدمة</li>
          </ul>
        </div>
      </div>
    </div>
    <!--end::Toolbar-->

    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10" id="section-content">
          <div class="col-12">
            <div class="card shadow-lg border-0 rounded-4 h-100 bg-light">
              <div class="card-body p-5">
                <!-- العنوان والايقونة -->
                <div class="text-center mb-5">
                  <div
                    href="#"
                    class="mb-0 mb-lg-2 custom-logo"
                    style="text-align: center"
                  >
                    <img
                      alt="Logo"
                      src="assets/img/logo-dark.png"
                      class="h-60px h-lg-75px"
                    />
                  </div>
                  <div
                    class="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle p-4 shadow-sm"
                  >
                    <i
                      class="fas fa-user-shield fa-1x text-success"
                      style="font-size: 18px"
                    ></i>
                  </div>
                  <h2 style="font-weight: 700" class="fw-bold mt-3 text-dark">
                    سياية الخصوصية | Privcy Policy
                  </h2>
                  <p class="text-muted">
                    تاريخ النفاذ / Effective Date: 21/09/2025
                  </p>
                </div>

                <!-- المحتوى باللغتين جنب بعض -->
                <div class="row gy-5">
                  <!-- Arabic Terms -->
                  <div class="col-lg-6 border-lg-end pe-lg-4">
                    <div class="terms-content" dir="rtl">
                      <p class="text-dark">
                        تقدّر منصة أكاديميا خصوصيتك. توضّح هذه السياسة كيف نجمع
                        ونستخدم ونشارك ونحمي معلوماتك عند استخدام تطبيقنا
                        التعليمي وخدماتنا المرتبطة. باستخدامك للتطبيق، فأنت
                        توافق على الممارسات الموضحة في هذه السياسة.
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        1. المعلومات التي نجمعها
                      </h5>
                      <ul>
                        <li>
                          المعلومات الشخصية: الاسم، رقم الهاتف، وبيانات الدفع
                          عند إنشاء حساب أو شراء دورة.
                        </li>
                        <li>
                          بيانات الاستخدام: تقدمك في الدورات، أوقات تسجيل
                          الدخول، وتفاعلك مع المحتوى.
                        </li>
                        <li>
                          معلومات الجهاز: عنوان الـIP، نوع المتصفح، نظام
                          التشغيل، ومعرّفات الجهاز.
                        </li>
                        <li>
                          معلومات الدفع: تتم معالجتها بأمان من خلال مزوّدي خدمة
                          خارجيين (نحن لا نخزن تفاصيل الدفع الكاملة).
                        </li>
                      </ul>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        2. كيفية استخدام المعلومات
                      </h5>
                      <ul>
                        <li>تقديم وصيانة وتحسين الخدمات.</li>
                        <li>تخصيص تجربة التعلم الخاصة بك.</li>
                        <li>معالجة المدفوعات وإرسال الإيصالات.</li>
                        <li>التواصل معك بخصوص الدورات والتحديثات.</li>
                        <li>
                          مراقبة الاستخدام، منع الاحتيال، وضمان أمان التطبيق.
                        </li>
                      </ul>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        3. مشاركة المعلومات
                      </h5>
                      <p class="text-dark">
                        لا نبيع أو نؤجر معلوماتك الشخصية. قد نشارك بياناتك مع:
                      </p>
                      <ul>
                        <li>
                          مقدمي الخدمات: مثل الاستضافة، الدفع، أو التحليلات.
                        </li>
                        <li>
                          الالتزامات القانونية: إذا طُلب ذلك بموجب القانون.
                        </li>
                        <li>
                          النقل التجاري: في حال الاندماج، الاستحواذ، أو بيع
                          الأصول.
                        </li>
                      </ul>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        4. الاحتفاظ بالبيانات
                      </h5>
                      <p class="text-dark">
                        نحتفظ بمعلوماتك الشخصية طالما كان ذلك ضروريًا لتقديم
                        الخدمات أو للامتثال للقانون أو لحل النزاعات.
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        5. أمان البيانات
                      </h5>
                      <p class="text-dark">
                        نطبق إجراءات تقنية وتنظيمية مناسبة لحماية معلوماتك، لكن
                        لا توجد وسيلة نقل عبر الإنترنت أو تخزين بيانات آمنة
                        بنسبة 100%.
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        6. حقوقك
                      </h5>
                      <p class="text-dark">قد تتمتع بحقوق مثل:</p>
                      <ul>
                        <li>الوصول إلى بياناتك أو تعديلها أو حذفها.</li>
                        <li>الاعتراض أو تقييد بعض المعالجات.</li>
                      </ul>
                      <p class="text-dark">
                        لطلب ذلك، يمكنك التواصل معنا عبر بوت الدعم:
                        <a
                          href="https://t.me/Academia_messeges_bot"
                          target="_blank"
                          class="fw-semibold"
                          >https://t.me/Academia_messeges_bot</a
                        >
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        7. تغييرات على السياسة
                      </h5>
                      <p class="text-dark">
                        قد نقوم بتحديث هذه السياسة من وقت لآخر. سنخطرك
                        بالتغييرات المهمة عبر نشر النسخة الجديدة مع تحديث "تاريخ
                        النفاذ".
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        8. تواصل معنا
                      </h5>
                      <p class="text-dark">
                        للاستفسارات:
                        <a
                          href="https://t.me/Academia_messeges_bot"
                          target="_blank"
                          class="fw-semibold"
                          >https://t.me/Academia_messeges_bot</a
                        >
                      </p>
                      <p class="text-dark">
                        📍 المكان: مركز أكاديميا – فرع الجامعة، مقابل مدرجات
                        كلية الهندسة بجامعة طرابلس، بمحاذاة السياج الخارجي لمسجد
                        الجامعة.
                      </p>

                      <a
                        href="https://maps.apple.com/?auid=14457113495649267365&ll=32.857007,13.215420&lsp=7618&q=Dropped%20Pin&t=m"
                        target="_blank"
                        style="
                          font-size: 13px !important;
                          padding: 10px !important;
                        "
                        class="btn btn-success mt-3 px-4 py-2 fw-bold fs-6 rounded-pill d-inline-flex align-items-center shadow-sm"
                      >
                        <i
                          class="fas fa-location-dot me-2 fs-5"
                          style="margin-right: 5px"
                        ></i>
                        عرض على الخريطة
                      </a>
                    </div>
                  </div>

                  <!-- English Terms -->
                  <div
                    class="col-lg-6 terms-col-en ps-lg-4"
                    style="padding: 16px 50px"
                  >
                    <div class="terms-content" dir="ltr">
                      <p class="text-dark">
                        Academia platform values your privacy. This Privacy
                        Policy explains how we collect, use, share, and
                        safeguard your information when you use our educational
                        application and related services. By using the app, you
                        agree to the practices described in this policy.
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        1. Information We Collect
                      </h5>
                      <ul>
                        <li>
                          Personal Information: Name, phone number, and billing
                          details when creating an account or purchasing a
                          course.
                        </li>
                        <li>
                          Usage Data: Course progress, login times, and
                          interactions with content.
                        </li>
                        <li>
                          Device Information: IP address, browser type,
                          operating system, and device identifiers.
                        </li>
                        <li>
                          Payment Information: Processed securely by third-party
                          providers (we do not store full payment details).
                        </li>
                      </ul>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        2. How We Use Your Information
                      </h5>
                      <ul>
                        <li>Provide, maintain, and improve services.</li>
                        <li>Personalize your learning experience.</li>
                        <li>Process payments and send receipts.</li>
                        <li>Communicate with you about courses and updates.</li>
                        <li>
                          Monitor usage, prevent fraud, and ensure app security.
                        </li>
                      </ul>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        3. Sharing of Information
                      </h5>
                      <p class="text-dark">
                        We do not sell or rent your personal data. We may share
                        information with:
                      </p>
                      <ul>
                        <li>
                          Service Providers: Hosting, payment processors, or
                          analytics.
                        </li>
                        <li>Legal Requirements: When required by law.</li>
                        <li>
                          Business Transfers: In case of merger, acquisition, or
                          asset sale.
                        </li>
                      </ul>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        4. Data Retention
                      </h5>
                      <p class="text-dark">
                        We retain personal data as long as necessary to provide
                        services, comply with legal obligations, or resolve
                        disputes.
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        5. Data Security
                      </h5>
                      <p class="text-dark">
                        We implement technical and organizational measures to
                        protect your data, but no online system is 100% secure.
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        6. Your Rights
                      </h5>
                      <p class="text-dark">You may have rights such as:</p>
                      <ul>
                        <li>Accessing, modifying, or deleting your data.</li>
                        <li>Objecting to or restricting certain processing.</li>
                      </ul>
                      <p class="text-dark">
                        To exercise these rights, please contact us via our
                        support bot:
                        <a
                          href="https://t.me/Academia_messeges_bot"
                          target="_blank"
                          class="fw-semibold"
                          >https://t.me/Academia_messeges_bot</a
                        >
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        7. Changes to This Policy
                      </h5>
                      <p class="text-dark">
                        We may update this Privacy Policy periodically.
                        Significant changes will be posted with an updated
                        "Effective Date."
                      </p>

                      <h5
                        class="fw-bold mt-4 text-dark"
                        style="font-weight: 700 !important"
                      >
                        8. Contact Us
                      </h5>
                      <p class="text-dark">
                        For inquiries: Support Bot
                        <a
                          href="https://t.me/Academia_messeges_bot"
                          target="_blank"
                          class="fw-semibold"
                          >https://t.me/Academia_messeges_bot</a
                        >
                      </p>
                      <p class="text-dark">
                        📍 Location: Academia Center – University Branch,
                        opposite Engineering Faculty lecture halls, University
                        of Tripoli gate, next to the outer fence of the
                        University Mosque.
                      </p>

                      <a
                        href="https://maps.apple.com/?auid=14457113495649267365&ll=32.857007,13.215420&lsp=7618&q=Dropped%20Pin&t=m"
                        target="_blank"
                        style="
                          font-size: 13px !important;
                          padding: 10px !important;
                        "
                        class="btn btn-success mt-3 px-4 py-2 fw-bold fs-6 rounded-pill d-inline-flex align-items-center shadow-sm"
                      >
                        <i
                          class="fas fa-location-dot me-2 fs-5"
                          style="margin-right: 5px"
                        ></i>
                        View on Map
                      </a>
                    </div>
                  </div>
                </div>
                <!-- end row -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
/* العمود الأيسر (العربي) */
.terms-col-ar {
  border-left: 2px solid #198754; /* أخضر */
  padding-left: 20px;
}

/* العمود الأيمن (الإنجليزي) */
.terms-col-en {
  border-right: 2px solid #00a81cff; /* أخضر */
  padding-right: 20px;
}

/* نخفي الحدود في الموبايل */
@media (max-width: 991.98px) {
  .terms-col-ar,
  .terms-col-en {
    border: none;
    padding: 0;
  }
}

/* تحسين النصوص */
.terms-content {
  line-height: 1.5;
  font-size: 15px;
  color: #333;
}

.terms-content h5 {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 6px;
  margin-bottom: 12px;
}
</style>
